import { ReactElement } from 'react';
import { TeachOptionsBaseProps } from '../teach.types';

export interface MoveOptionsProps extends TeachOptionsBaseProps {}

const TeachMoveOptions = (props: MoveOptionsProps): ReactElement => {
  const { onAdd: _onAdd } = props;

  return <div></div>;
};

export { TeachMoveOptions };
